import types from '@/vuex/juntada/actions-types'
import documentos from '@/utils/documentos'
import router from '@/router'

const actions = {
  [types.SET_PASSO_ATUAL]: ({ commit }, payload) => commit(types.SET_PASSO_ATUAL, payload),
  [types.SET_LISTA_DOCUMENTOS]: ({ commit }, payload) => commit(types.SET_LISTA_DOCUMENTOS, payload),
  [types.SET_TIPO_JUNTADA_SELECIONADA]: ({ commit }, payload) => commit(types.SET_TIPO_JUNTADA_SELECIONADA, payload),
  [types.GET_DOCUMENTO_SELECIONADO]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
      commit(types.SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} })
      const response = await documentos.getListaDocumentos({numeroDocumento: payload.documentoSelecionado.numeroDocumento})
      let infoDocumento = response.data.find(documento => documento.idDocumento === payload.documentoSelecionado.idDocumento)
      commit(types.SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: infoDocumento })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
    }
  },
  [types.SET_DOCUMENTO_SELECIONADO]: ({ commit }, payload) => commit(types.SET_DOCUMENTO_SELECIONADO, payload),

  [types.GET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
      commit(types.SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} })
      commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: [] })
      const response = await documentos.getListaDocumentosParaJuntada(payload.numeroDocumento)
      if (response.data.length === 0) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Nenhum documento encontrado' }, {root: true})
      } else {
        let listaDocumentos = []
        try {
          commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando documentos agregados' }, {root: true})
          for (let documento of response.data) {
            let vinculos = (await documentos.getListaVinculosDocumento(documento.idDocumento)).data
            if (vinculos.some(vinculo => vinculo.tipoAgregacao === 'APENSACAO')) listaDocumentos.push({ ...documento, possuiApensados: true })
            else listaDocumentos.push({ ...documento, possuiApensados: false })
          }
          commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: listaDocumentos })
        } catch (error) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar a presença de documentos agregados' }, {root: true})
          throw error
        } finally {
          commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando documentos agregados' }, {root: true})
        }
      }
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
    }
  },

  [types.JUNTAR_DOCUMENTOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Juntando documentos' }, {root: true})
      await documentos.juntarDocumentos(payload.tipoJuntadaSelecionada, payload.documentoSelecionado, payload.documento)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `Documento ${payload.documentoSelecionado.numero} ${payload.tipoJuntadaSelecionada.tipo === 'X' ? 'anexado' : 'apensado'} a ${payload.documento.numero} com sucesso` }, {root: true})
      router.push({name: 'InformacoesDocumento', params: {documentId: payload.documento.idDocumento}})
    } catch (error) {
      if (error.status === 500) commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
      else commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ocorreu um erro desconhecido ao tentar juntar documentos. Por favor, entre em contato com o administrador.' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Juntando documentos' }, {root: true})
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/juntada/actions.js